import ProductSort from 'components/Catalog/ProductSort/ProductSort';

export default ProductSort;
